import { Injectable } from '@angular/core';

export interface AppOptions {
  appCode: number | string;
  appName: 'semux' | 'dcmonitor' | 'admin' | 'app';
  eventsLog: {objects: boolean; units: boolean; places: boolean};
  appConfig: {
    mainDashboard?: number;
    logoUrl?: string;
    mainBackgroundUrl?: string;
    typeOfDefaultUrl: 'static'|'dynamic';
    defaultUrl?: string;
  };
  charts: {
    groupBy: 'sensorLocation' | 'controller';
    parameters: boolean;
    objects: boolean;
    events: boolean;
    dashboards: boolean;
  };
}
@Injectable({
  providedIn: 'root'
})
export class ConfigureService {
   constructor(public options: AppOptions) { }
}
